export default {
  navigationBarTitleText: '接入jsSdk',
};
